const sortByPosition = (arr) => {
  return arr.sort((a, b) => {
    const positionA = parseInt(a.position.split(' ')[0]);
    const positionB = parseInt(b.position.split(' ')[0]);
    return positionA - positionB;
  });
};
const pageViewNews = (params) => {
  if (params && params.length > 0) {
    const dataCategory = params.map((data) => ({ ...data, category: data.category }));
    if (typeof window !== 'undefined') {
      params.forEach((data) => delete data.category);
      (window as any)?.dataLayer?.push({
        event: 'promotionView',
        eventCategory: 'ecommerce promotion',
        eventLabel: `${
          (dataCategory?.every((val) => val?.category === dataCategory[0]?.category)
            ? dataCategory?.[0]?.category
            : 'semua') ?? 'semua'
        }`,
        ecommerce: {
          promoView: {
            promotions: sortByPosition(params),
          },
        },
      });
    }
  }
};
export default pageViewNews;
